export default "/images/pocket.svg?b99de34a551a968511398dc4d8ee3b52";